window.Blimp = window.Blimp || {};

function chunk(arr, chunkSize) {
  if (chunkSize <= 0) {
    throw 'Invalid chunk size';
  }
  const R = [];
  let i = 0;
  const len = arr.length;
  while (i < len) {
    R.push(arr.slice(i, i + chunkSize));
    i += chunkSize;
  }
  return R;
}

class ReportView extends Backbone.View {
  get className() {
    return 'report';
  }

  get events() {
    return {
      'click .delete': 'delete',
      'click .edit_groups': 'edit_groups',
      'click .group_edit .save': 'save_groups',
      'click .group_edit .cancel': 'cancel_edit_groups',
      'click .comment .save': 'update_comment',
      'click .comment .cancel': 'cancel_update_comment',
      'keydown .comment textarea': 'show_comment_buttons'
    };
  }

  initialize() {
    this.listenTo(this.model, 'remove', () => {
      this.trigger('remove', this);
      this.remove();
    });
  }

  renderGroups(groups) {
    const g = $('<div class="group_tags" />');
    groups.forEach((group) => {
      g.append(`<div class="group">${group}</div>`);
    });
    return g;
  }

  questionAnswerFormatted(question) {
    if (question.type === 'temperature') {
      return `${question.answer} °C`;
    }
    return question.answer;
  }

  render() {
    const head = $('<div class="head"/>');

    const title = $(`<a class="title" href="${this.model.url()}"/>`);
    _.each(this.model.get('references'), (ref) => {
      title.append(`<div class="ref">${ref}</div>`);
    });

    const groupNames = this.model.groups.models.map((x) => x.attributes.name);
    const groupTags = this.renderGroups(groupNames);
    title.append(groupTags);

    head.append(title);
    const right = $('<div class="right"/>');
    if (Blimp.can_delete_reports) {
      right.append('<a href="#" class="delete">Delete</a>');
    }
    if (Blimp.feature_group_edit) {
      right.append('<a href="#" class="edit_groups">Change groups</a>');
    }
    if (Blimp.mode === 'search' || (Blimp.mode === 'single' && Blimp.is_authenticated)) {
      right.append(`<a href="${this.model.related_url()}">Related</a>`);
    }
    right.append(`<a href="${this.model.pdf_url()}" target="_blank"><i class="fa fa-file-text-o fa-lg"></i> PDF</a>`);
    if (this.model.photos.length) {
      right.append(`<a href="${this.model.zip_url()}" target="_blank"><i class="fa fa-archive fa-lg"></i> ZIP</a>`);
    }
    head.append(right);
    this.$el.append(head);

    if (Blimp.feature_group_edit) {
      const model_groups = this.model.groups;
      const group_edit = $('<div class="group_edit"/>');
      group_edit.append('<p>Select groups:</p>');

      const breakAt = 10;
      const columns = Math.min(4, Math.ceil(Blimp.all_groups.length / breakAt));

      const groups = $('<div class="groups_boxes"/>');
      groups.css('column-count', columns);

      const group_ids = model_groups.models.map((x) => x.attributes.id);

      chunk(Blimp.all_groups, breakAt).forEach((groupChunk) => {
        const column = $('<div />');
        groupChunk.forEach((accountGroup) => {
          const group = $('<div class="group"/>');
          const checked = group_ids.includes(accountGroup.id) ? 'checked' : '';
          group.append(`<input type='checkbox' name='user[group_ids][]' id='group_${accountGroup.id}' value='${accountGroup.id}' class='group-inputs' ${checked} />`);
          group.append(`<label for='group_${accountGroup.id}'> ${accountGroup.name}</label>`);
          column.append(group);
        });
        groups.append(column);
      });
      group_edit.append(groups);
      group_edit.append('<button class="button save">Save</button>');
      group_edit.append('<button class="button outline cancel">Cancel</button>');
      this.$el.append(group_edit);
    }

    this.$el.append(`<div class="details">Created by ${this.model.user.get('name')} on ${this.model.date().format('dddd, YYYY-MM-DD, HH:mm (UTC Z)')}</div>`);

    if (this.model.get('questionnaire_answers')) {
      for (const questionnaire of this.model.get('questionnaire_answers')) {
        const htmlString = `
        <table class="questionnaire_table">
          <thead>
            <tr><th colspan="2">${questionnaire[0].question}</th></tr>
          </thead>
          <tbody>
            ${questionnaire.slice(1).map((question) => `<tr><td style='padding-left: ${10 + question.nesting_level * 20}px'>${question.question}</td><td style="width: 240px;">${this.questionAnswerFormatted(question)}</td></tr>`).join('')}
          </tbody>
        </table>
        `;
        this.$el.append(htmlString);
      }
    }

    if (this.model.get('additional_info')) {
      if (this.model.get('additional_info') instanceof Array && this.model.get('additional_info')[0] && this.model.get('additional_info')[0].infoType) {
        const appendTr = (array, options = '') => {
          let string = `<tr${options}>`;
          _.each(array, (val) => string += `<td>${val || ''}</td>`);
          string += '</tr>';
          return string;
        };
        const appendTh = (array) => {
          let string = '<thead>';
          _.each(array, (val) => string += `<th>${val || ''}</th>`);
          string += '</thead>';
          return string;
        };
      } else {
        const renderJson = (json) => {
          let string = "";
          for (const objType in json) {
            if (typeof json[objType] === 'object') {
              string += renderJson(json[objType]) + '<br>';
            } else {
              string += objType + ': <strong>' + json[objType] + '</strong> ';
            }
          }
          return string;
        };
        const additional_info_string = renderJson(this.model.get('additional_info'));
        this.$el.append(`<div class="additional_info">${additional_info_string}</div>`);
      }
    }

    if (Blimp.feature_comments) {
      const comment = $('<div class="comment"/>');
      if (Blimp.can_edit_comments) {
        comment.append(`<textarea placeholder="No comment">${this.model.get('comment') || ''}</textarea>`);
        comment.append('<button class="button save" style="display: none">Save</button>');
        comment.append('<button class="button outline cancel" style="display: none">Cancel</button>');
      } else {
        comment.append(`<textarea placeholder="No comment" disabled="disabled">${this.model.get('comment') || ''}</textarea>`);
      }
      this.$el.append(comment);
    }

    const photos = $('<div class="photos"/>').append(_.map(this.model.photos.models, (model) => {
      return new Blimp.PhotoView({ model: model }).render().el;
    }));
    this.$el.append(photos);

    if (this.model.get('limited')) {
      this.$el.addClass('limited');

      const lockText = $("<div class='lock'><div class='lockinfo'><i class='fa fa-lock fa-4x'></i><span style='max-width: 600px'>You cannot see the details to this report since it was created after crossing the monthly limit of 50 free photos. For more information please contact us via <a href='mailto:support@blimp-app.com'>support@blimp-app.com</a></span></div></div>");
      this.$el.append(lockText);
    }
    return this;
  }

  delete() {
    if (confirm("Are your sure you want to delete this report?")) {
      this.model.destroy();
    }
    return false;
  }

  edit_groups() {
    this.$el.find('.group_edit').toggle();
  }

  cancel_edit_groups() {
    this.$el.find('.group_edit').hide();
  }

  save_groups() {
    const ids = this.$el.find('.groups_boxes input[type=checkbox]:checked').map((idx, el) => parseInt(el.value)).toArray();
    const objects = Blimp.all_groups.filter((x) => ids.includes(x.id));
    const names = objects.map((x) => x.name);

    this.model.set({ groups: objects });
    this.model.save();

    const groups = this.renderGroups(names);
    $(".group_tags").remove();
    $(".title").append(groups);

    this.$el.find('.group_edit').hide();
  }

  update_comment() {
    this.model.set({ comment: this.$el.find('.comment textarea').val() });
    this.model.save();
    this.$el.find('.comment button').hide();
  }

  cancel_update_comment() {
    this.$el.find('.comment textarea').val(this.model.get('comment'));
    this.$el.find('.comment button').hide();
  }

  show_comment_buttons() {
    this.$el.find('.comment button').show();
  }
}

Blimp.ReportView = ReportView;